<template>
  <Card class="DealFilterTable">
    <!-- Distributor, Customer type -->
    <FormItemGroup>
      <FilterDistributor />
      <FilterCustomerType />
      <FilterPowerMeasurement v-if="showPowerMeasurementAndConsumer" />
    </FormItemGroup>
    <!-- /Distributor, Customer type -->

    <!-- Meter type -->
    <FormItemGroup v-show="showMeterType">
      <FilterMeterType />
    </FormItemGroup>
    <!-- /Meter type -->

    <!-- Reactive energy type -->
    <FormItemGroup v-show="showReactiveEnergyType">
      <FilterReactiveEnergyType />
    </FormItemGroup>
    <!-- /Reactive energy type -->

    <!-- Reactive energy calculation -->
    <FormItemGroup v-show="showReactiveEnergyCalculation">
      <FormItemGroupTitle>
        {{ $t('formItemGroupTitleReactiveEnergy') }}
      </FormItemGroupTitle>
      <CalculationReactiveEnergyHT />
      <CalculationReactiveEnergyLT v-show="!singleRate" />
    </FormItemGroup>
    <!-- /Reactive energy calculation -->

    <!-- Consumption category -->
    <FormItemGroup v-if="showPowerMeasurementAndConsumer">
      <FilterConsumptionCategory/>
    </FormItemGroup>
    <!-- /Consumption category -->

    <!-- Active energy -->
    <FormItemGroup>
      <FormItemGroupTitle>
        {{ $t('formItemGroupTitleActiveEnergy') }}
      </FormItemGroupTitle>
      <CalculationActiveHT />
      <CalculationActiveLT v-show="!singleRate" />
    </FormItemGroup>
    <!-- /Active energy -->
  </Card>
</template>

<script>
import Card from '@/components/Card.vue';
// Form item layout elements
import FormItemGroup from '@/components/formItem/Group.vue';
import FormItemGroupTitle from '@/components/formItem/GroupTitle.vue';
import FormItemSectionTitle from '@/components/formItem/SectionTitle.vue';
// Filter form items
import FilterDistributor from '@/components/filter/Distributor.vue';
import FilterCustomerType from '@/components/filter/CustomerType.vue';
import FilterMeterType from '@/components/filter/MeterType.vue';
import FilterPowerMeasurement from '@/components/filter/PowerMeasurement.vue';
import FilterConsumptionCategory from '@/components/filter/ConsumptionCategory.vue';
import FilterReactiveEnergyType from '@/components/filter/ReactiveEnergy.vue';
// Calculation form items
import CalculationActiveHT from '@/components/calculation/ActiveHT.vue';
import CalculationActiveLT from '@/components/calculation/ActiveLT.vue';
import CalculationReactiveEnergyHT from '@/components/calculation/ReactiveEnergyHT.vue';
import CalculationReactiveEnergyLT from '@/components/calculation/ReactiveEnergyLT.vue';

export default {
  name: 'DealFilterTable',
  components: {
    Card,
    FormItemGroup,
    FormItemGroupTitle,
    FormItemSectionTitle,
    FilterDistributor,
    FilterCustomerType,
    FilterMeterType,
    FilterPowerMeasurement,
    FilterConsumptionCategory,
    FilterReactiveEnergyType,
    CalculationReactiveEnergyLT,
    CalculationReactiveEnergyHT,
    CalculationActiveHT,
    CalculationActiveLT,
  },
  computed: {
    customerType() {
      return this.$store.state.filter.activeFilters.customerType;
    },
    singleRate() {
      return this.$store.getters['filter/singleRate'];
    },
    reactiveEnergyType() {
      return this.$store.state.filter.reactiveEnergyType;
    },
    powerMeasurement() {
      return this.$store.state.filter.activeFilters.powerMeasurement;
    },
    showMeterType() {
      const { customerType, powerMeasurement } = this;
      if (customerType === 1) return true;
      else if (customerType === 5 && powerMeasurement === 'without') return true;
      return false;
    },
    showReactiveEnergyCalculation() {
      const { customerType, powerMeasurement, reactiveEnergyType } = this;
      if (customerType === 3 || customerType === 4 || (customerType === 5 && powerMeasurement === 'with') || (customerType === 5 && reactiveEnergyType === 'with')) return true;
      return false;
    },
    showReactiveEnergyType() {
      const { customerType, powerMeasurement } = this;
      if (customerType === 5 && powerMeasurement === 'without') return true;
      return false;
    },
    showPowerMeasurementAndConsumer() {
      const { customerType } = this;
      return customerType === 5;
    },
  },
  created() {
    console.log('customer type', this.customerType);
  },
};
</script>

<style scoped lang="scss">
.DealFilterTable {
  background-color: #fff;
  overflow: hidden;
}
</style>
